import * as React from "react";
import HomeView from "../views/Home/HomeView";
import {graphql} from "gatsby";
import {Post} from "../types/Post";

const index = ({data}) => {
	const posts: { node: Post }[] = data.allMdx.edges;
	return (
		<div>
			<HomeView
				posts={posts}
			/>
		</div>
	);
};

export default index;

export const query = graphql`
	query($language: String!) {
		locales: allLocale(filter: {language: {eq: $language}}) {
			edges {
				node {
					ns
					data
					language
				}
			}
		}
		allMdx(
			filter: {frontmatter: {locale: {eq: $language}, layout: {eq: "post"}}},
			sort: {fields: frontmatter___date, order: DESC}
			limit: 6
		) {
			edges {
				node {
					frontmatter {
						date
						title
						slug
						ogImage {
							publicURL
						}
					}
				}
			}
		}
	}
`;
